<script setup lang="ts">
// Ask-HVAC.com — app shell for the 2026 redesign (ASKHVAC-REDESIGN.md).
//
// The shell is chrome only: header, routed page, trust bar, footer. Pages
// live in views/ and land milestone by milestone — Home (M2) is rebuilt to
// the mockups; the rest are either interim (existing working machinery
// under the new chrome) or an honest in-progress page.
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import SiteConfigProvider from '@/shared/naive/SiteConfigProvider.vue'
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import TrustBar from './components/TrustBar.vue'

const route = useRoute()
const activeNav = computed(() => route.meta.nav as string | undefined)
</script>

<template>
    <SiteConfigProvider>
        <AppHeader :active="activeNav" />
        <main>
            <RouterView />
        </main>
        <TrustBar />
        <AppFooter />
    </SiteConfigProvider>
</template>
